import React, { useEffect, useState } from 'react';
import './Home.scss';
import { FormattedMessage } from 'react-intl';
import { Button as KitButton, EButtonType, SpinnerV2 } from '@repo/apg-ui';
import { connect, useSelector } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import { AppState } from '../../store';
import { productsActions } from '../../store/products';
import { Loading, UiActions } from '../../store/ui';
import 'react-date-range/dist/theme/default.css';
import 'react-date-range/dist/styles.css';
import CalculationModal from '../../components/Modal/CalculationModal';
import { searchActions as _searchActions } from '../../store/search';
import * as _actionsBasket from '../../store/products/actions';
import { useLocation } from 'react-router-dom';

interface Props {
  loading: Loading;
  uiActions: typeof UiActions;
  searchActions: typeof _searchActions;
  actionsBasket: typeof _actionsBasket;
}

const Home = ({ loading, uiActions, searchActions, actionsBasket }: Props) => {
  const [show, setShow] = useState(false);
  const location = useLocation();
  const basketData = useSelector((state: AppState) => state.products.basket);

  const handleClose = () => setShow(false);
  const handleShow = () => {
    setShow(true);
  };

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    if (searchParams.get('modal') === 'calculation') {
      setShow(true);
    }
  }, [location]);

  const clearBasket = () => {
    const payload = {
      entries: 'all',
      basketreference: basketData.reference,
      basket: basketData.id,
    };
    try {
      const response = actionsBasket.removeFromBasket(payload);
      if (response) {
        actionsBasket.clearBasket();
        actionsBasket.removeBasketData();
      } else {
        console.error('Failed to remove item from basket:', response);
      }
    } catch (err) {
      console.error('Error removing item from basket:', err);
    }
  };

  useEffect(() => {
    uiActions.setIsShowBottomBar(false);
    searchActions.setShowIsUnavailable(true);
    if (localStorage.getItem('basketDataDC') || basketData) {
      localStorage.removeItem('basketDataDC');
      clearBasket();
    }
  }, []);

  return (
    <div className='bg-gray-light d-flex p-5 justify-content-center align-items-center h-100'>
      <div className='bg-white p-5'>
        <h1 className='text-center pb-5'>eCalculator</h1>
        <p className='text-center font-weight-bold'>
          <FormattedMessage
            id={'home.subheader.instruction'}
            defaultMessage={'Beginnen Sie, indem Sie unten auf die Schaltfläche „Neue Kalkulation“ klicken.'}
          />
        </p>
        <div className='text-center'>
          <KitButton buttonType={EButtonType.PillMedium} onClick={handleShow}>
            <FormattedMessage id={'home.button.newCalculation'} defaultMessage={'+ Neue Kalkulation'} />
          </KitButton>
        </div>
        <CalculationModal show={show} handleClose={handleClose} />
        {loading.general && <SpinnerV2 />}
      </div>
    </div>
  );
};

function mapStateToProps(state: AppState, ownProps: any) {
  return {
    ...ownProps,
    ...state.products,
    ...state.locations,
    ...state.ui,
  };
}

function mapDispatchToProps(dispatch: Dispatch) {
  return {
    actions: bindActionCreators(productsActions as any, dispatch),
    uiActions: bindActionCreators(UiActions as any, dispatch),
    searchActions: bindActionCreators(_searchActions as any, dispatch),
    actionsBasket: bindActionCreators(_actionsBasket as any, dispatch),
    dispatch: dispatch,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Home);
